<template>
  <div>
    <el-row>
      <el-col :span="20" style="margin-top: 20px">
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="产品名称：">
            <el-input size="medium" v-model="searchForm.PRODUCT_NAME"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="handleCurrentChange(1)" style="float:right">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table border stripe :data="tableData">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
          <el-table-column prop="NAME" label="产品名称"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="出库数量"></el-table-column>
          <el-table-column prop="SEND_COUNT" label="实发数量"></el-table-column>
          <el-table-column prop="RETURN_COUNT" label="退货数量">
            <template slot-scope="scope">
              <el-input v-model="scope.row.RETURN_COUNT"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="WASTAGE_COUNT" label="报损数量">
            <template slot-scope="scope">
              <el-input v-model="scope.row.WASTAGE_COUNT"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="submitEdit(scope.row)" type="text">提交</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- <el-row> -->
    <!-- <el-col :span="10" :offset="14">
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage"
              :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="totalCount">
            </el-pagination>
            </el-col>
        </el-row> -->
    <div class="pagination_box" style="float: right">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </div>
    <div style="clear: both"></div>
    <el-row>
      <el-col :span="2" :offset="22">
        <el-button @click="overSubmit()" style="margin-top: 20px;margin-bottom: 20px">完成报损</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { reportLossFun, submitReportFun, overReportFun } from 'api/warehouseManager';

export default {
  data() {
    return {
      tableData: [],
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
      searchForm: {},
    };
  },
  methods: {
    queryTable(e) {
      const params = {
        DELIVER_ID: sessionStorage.getItem('deliverId'),
        PAGESIZE: this.pageSize,
        PAGEINDEX: e,
      };
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      reportLossFun(params).then((result) => {
        if (result[0]) {
          this.tableData = result[0].LIST.map((item) => Object.assign(item, { SEND_COUNT: Math.round((item.PRODUCT_COUNT - item.RETURN_COUNT - item.WASTAGE_COUNT) * 100) / 100 }));
          this.totalCount = result[0].TOTAL_COUNT;
        } else {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryTable(e - 1);
    },
    submitEdit(row) {
      const params = {
        DETAIL_ID: row.ID,
        RETURN_COUNT: Number(row.RETURN_COUNT),
        WASTAGE_COUNT: Number(row.WASTAGE_COUNT),
      };
      submitReportFun(params).then((result) => {
        this.$message.show({ text: '提交成功', type: 'success' });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    overSubmit() {
      const params = {
        DELIVER_ID: sessionStorage.getItem('deliverId'),
      };
      overReportFun(params).then((result) => {
        this.$message.show({ text: '提交成功', type: 'success' });
        this.$router.push({ name: 'totalOutWareDoc' });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryTable(0);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/warehouseManage/reportLoss.vue